module.exports = __webpack_public_path__ + "images/choices/qrcode-mydreamplus-a5440223ea1ced934bd911d59f823c57.jpg";